import 'bootstrap';
import './components/carousel';
import './components/fade-up-animation';
import './components/scroll-mask';
import '../scss/style.scss';
